import React, { useState } from 'react';
import InputComponent from './form/InputComponent';
import CheckboxComponent from './form/CheckboxComponent';
import '../pages/Statistics.css'; // Reuse existing styles or create new ones

interface CustomStatisticsModalProps {
    isOpen: boolean;
    onClose: () => void;
    onGenerate: (filters: any) => void;
}

const CustomStatisticsModal: React.FC<CustomStatisticsModalProps> = ({ isOpen, onClose, onGenerate }) => {
    const [filters, setFilters] = useState({
        dateFrom: '',
        dateTo: '',
        facebookInstagramEnabled: false,
        linkedinEnabled: false,
        minSpending: '',
        maxSpending: '',
        geotargeting: '',
        annonseformat: ''
    });

    if (!isOpen) return null;

    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        const { name, value, type } = e.target;
        setFilters(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? (e.target as HTMLInputElement).checked : value
        }));
    };

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        onGenerate(filters);
    };

    return (
        <div className="modal-overlay">
            <div className="modal-content" style={{ maxWidth: '600px' }}>
                <div className="modal-header">
                    <h2>Lag egendefinert statistikk</h2>
                    <button className="close-button" onClick={onClose}>&times;</button>
                </div>

                <form onSubmit={handleSubmit}>
                    <div className="modal-body">
                        <p className="modal-description">
                            Velg filtre for å generere statistikk. La felter stå tomme for å inkludere alt.
                        </p>

                        <div className="form-section" style={{ padding: 0, border: 'none', background: 'transparent' }}>
                            <h3 className="section-subtitle">Periode</h3>
                            <div className="form-row">
                                <div className="form-col half">
                                    <InputComponent
                                        label="Fra dato"
                                        type="date"
                                        name="dateFrom"
                                        value={filters.dateFrom}
                                        onChange={handleChange}
                                    />
                                </div>
                                <div className="form-col half">
                                    <InputComponent
                                        label="Til dato"
                                        type="date"
                                        name="dateTo"
                                        value={filters.dateTo}
                                        onChange={handleChange}
                                    />
                                </div>
                            </div>

                            <h3 className="section-subtitle">Kanaler</h3>
                            <div className="form-row">
                                <div className="form-col half">
                                    <CheckboxComponent
                                        label="Facebook / Instagram"
                                        name="facebookInstagramEnabled"
                                        value="true"
                                        checked={filters.facebookInstagramEnabled}
                                        onChange={handleChange}
                                    />
                                </div>
                                <div className="form-col half">
                                    <CheckboxComponent
                                        label="LinkedIn"
                                        name="linkedinEnabled"
                                        value="true"
                                        checked={filters.linkedinEnabled}
                                        onChange={handleChange}
                                    />
                                </div>
                            </div>

                            <h3 className="section-subtitle">Økonomi</h3>
                            <div className="form-row">
                                <div className="form-col half">
                                    <InputComponent
                                        label="Min. spending (kr)"
                                        type="number"
                                        name="minSpending"
                                        value={filters.minSpending}
                                        onChange={handleChange}
                                        placeholder="0"
                                    />
                                </div>
                                <div className="form-col half">
                                    <InputComponent
                                        label="Maks. spending (kr)"
                                        type="number"
                                        name="maxSpending"
                                        value={filters.maxSpending}
                                        onChange={handleChange}
                                        placeholder="Ubegrenset"
                                    />
                                </div>
                            </div>

                            <h3 className="section-subtitle">Detaljer</h3>
                            <div className="form-row">
                                <div className="form-col half">
                                    <InputComponent
                                        label="Geotargeting (fritekst)"
                                        name="geotargeting"
                                        value={filters.geotargeting}
                                        onChange={handleChange}
                                        placeholder="F.eks. Oslo"
                                    />
                                </div>
                                <div className="form-col half">
                                    <div className="input-group">
                                        <label className="input-label">Annonseformat</label>
                                        <select
                                            name="annonseformat"
                                            value={filters.annonseformat}
                                            onChange={handleChange}
                                            className="form-input"
                                        >
                                            <option value="">Alle formater</option>
                                            <option value="bilde">Bilde</option>
                                            <option value="video">Video</option>
                                            <option value="karusell">Karusell</option>
                                            <option value="jobbannonse">Jobbannonse</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="modal-footer">
                        <button type="button" className="btn-secondary" onClick={onClose}>Avbryt</button>
                        <button type="submit" className="btn-primary">Generer statistikk</button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default CustomStatisticsModal;
